export default "__VITE_ASSET__BvENceEQ__"